import type { FC } from 'react';
import { useCallback, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@ui/dialog.tsx';
import { Button } from '@ui/button.tsx';
import { StepForm } from '@admin/components/forms/steps/steps-form.tsx';
import type { LogicTypeStepWorkspaceWriteJsonMergePatchModel as Step } from '@r/api/generated/client.schemas.ts';
import { useTranslation } from 'react-i18next';

interface CreateStepDialogProps {
  onStepCreated: (step: Step) => void;
}

export const CreateStepDialog: FC<CreateStepDialogProps> = ({ onStepCreated }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const handleSuccess = useCallback(
    (step: Step) => {
      onStepCreated(step);
      setIsOpen(false);
    },
    [onStepCreated]
  );

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button rounded="full" className="mt-6">
          {t('form.step.add.step')}
        </Button>
      </DialogTrigger>

      <DialogContent className="p-10 !rounded-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t('form.step.add.step')}</DialogTitle>
        </DialogHeader>
        <StepForm onSubmitStep={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
};
